export default __webpack_public_path__ + "static/media/beach-bg.b445b9fb.png";